import React from "react";
import { get, isNil } from "lodash";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

import { useGetWorkSpaceProfitabilityQuery } from "~/schemas/generated/graphql";
import { getIndicatorName } from "~/libs/getData";
import { getIndicatorPeriod } from "~/libs/getFormatDate";
import { DATA_STATUS_TYPES } from "~/constans/statuses";
import { useCurrentDealerId } from "~/shared/hooks/useCurrentDealerId";

import PanelWrapper from "~/components/PanelWrapper";

import s from "./BlockProfitability.less";

const BlockProfitability = () => {
  const { t } = useTranslation();
  const currentDealerId = useCurrentDealerId();
  const { data, loading } = useGetWorkSpaceProfitabilityQuery({
    variables: {
      DealerId: currentDealerId,
    },
    fetchPolicy: "cache-and-network",
  });

  const dealerProfitabilities = get(
    data,
    "WorkSpaceGetter.getProfitability",
    {}
  );

  return (
    <PanelWrapper
      width={220}
      height={220}
      label={t("dealers.profitability")}
      customClassName={s.new_car_padding}
      loading={loading}
    >
      <div className={s.prof}>
        <ul className={s.list}>
          {Object.values(dealerProfitabilities).map(
            ({ Indicator = { id: "" }, doubleValue, createdAt }) => {
              const id = get(Indicator, "id");
              return (
                id && (
                  <li
                    key={id}
                    className={clsx({
                      [s.active]: id === "600",
                    })}
                  >
                    <div className={s.left}>
                      {getIndicatorName(Indicator)}{" "}
                      {getIndicatorPeriod({ createdAt }, "specQuarter")}:
                    </div>
                    <div className={s.right}>
                      {!isNil(doubleValue)
                        ? `${doubleValue}%`
                        : DATA_STATUS_TYPES.ND}
                    </div>
                  </li>
                )
              );
            }
          )}
        </ul>
      </div>
    </PanelWrapper>
  );
};

export default BlockProfitability;
